import { render, staticRenderFns } from "./BrickDedupBaseSettings.vue?vue&type=template&id=44d30c74&scoped=true&"
import script from "./BrickDedupBaseSettings.vue?vue&type=script&lang=js&"
export * from "./BrickDedupBaseSettings.vue?vue&type=script&lang=js&"
import style0 from "./BrickDedupBaseSettings.vue?vue&type=style&index=0&id=44d30c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d30c74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d30c74')) {
      api.createRecord('44d30c74', component.options)
    } else {
      api.reload('44d30c74', component.options)
    }
    module.hot.accept("./BrickDedupBaseSettings.vue?vue&type=template&id=44d30c74&scoped=true&", function () {
      api.rerender('44d30c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickDedupBaseSettings.vue"
export default component.exports